import React from "react";
import { Table } from "react-bootstrap";
import Tree from "react-d3-tree";
import { useCenteredTree } from "./helpers";
import "./styles.css";

const containerStyles = {
  width: "100%",
  // height: "100vh",
  height:"100%"
};

// Here we're using `renderCustomNodeElement` render a component that uses
// both SVG and HTML tags side-by-side.
// This is made possible by `foreignObject`, which wraps the HTML tags to
// allow for them to be injected into the SVG namespace.
const renderForeignObjectNode = ({
  nodeDatum,
  toggleNode,
  foreignObjectProps
}) => (
  <g>
    <circle r={15}></circle>
    {/* `foreignObject` requires width & height to be explicitly set. */}
    <foreignObject {...foreignObjectProps}>
      <div style={{ border: "1px solid black", backgroundColor: nodeDatum.attributes.color }}>
        <h6 style={{ textAlign: "center" }}>{nodeDatum.name}</h6>
        <Table>
            
            <tbody>
                <tr>
                    <td>Condition</td>
                    <td>{nodeDatum.attributes.condition_value}</td>
                </tr>
                
                <tr>
                    <td>Type </td>
                    <td>{nodeDatum.attributes.field_type_name}</td>
                </tr>
                
                
                <tr>
                    <td>Is Mandatory</td>
                    <td>{nodeDatum.attributes.is_mandatory}</td>
                </tr>
               
            </tbody>
        </Table>
        {nodeDatum.children && (
          <button style={{ width: "100%" }} onClick={toggleNode}>
            {nodeDatum.__rd3t.collapsed ? "Expand" : "Collapse"}
          </button>
        )}
      </div>
    </foreignObject>
  </g>
);

export default function CustomTree(props) {
  const [translate, containerRef] = useCenteredTree();
  const nodeSize = { x: 300, y: 300 };
  const foreignObjectProps = { width: nodeSize.x+20, height: nodeSize.y , x:15 };
  return (
    <div style={containerStyles} ref={containerRef}>
      <Tree
        data={props.surveyFields}
        translate={translate}
        pathFunc="step"
        zoom={0.6}
        separation={{siblings:2,nonSiblings:2}}
        nodeSize={nodeSize}
        renderCustomNodeElement={(rd3tProps) =>
          renderForeignObjectNode({ ...rd3tProps, foreignObjectProps })
        }
        orientation="vertical"
      />
    </div>
  );
}
